import { RolPolicy } from "./RolPolicy"

export const rolPolicy = new RolPolicy()